require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-lifting-heavy.json") })
        }
      }, "path---blog-lifting-heavy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-lifting-heavy!./.cache/json/blog-lifting-heavy.json
// module id = 297
// module chunks = 231608221292675